<div class="app-full-height px-4 pt-4 space-y-4">
  <div class="flex flex-col md:flex-row md:space-x-4 md:space-y-0 space-y-4">
    <mat-card class="w-full md:basis-2/3 flex-grow" appearance="outlined">
      <mat-card-content>
        <ng-container *ngIf="job$ | async as job; else loading">
          <app-workshop-job-details
            [job]="job"
            [repairDocket]="repairDocket$ | async"
            [templateName]="templateName$ | async"
          ></app-workshop-job-details>
          <ng-container *ngIf="attributes$ | async as attributes">
            <app-tracked-attributes-prompt
              *ngIf="attributes.length > 0"
              [attributes]="attributes$ | async"
              event="workshop_job_complete"
              [promptableId]="(job$ | async)?.id"
              promptableType="workshopJob"
              [itemCode]="(job$ | async)?.repairable.code"
              [itemId]="(job$ | async)?.repairable.id"
              (addedAttributes)="clearAttributes()"
            ></app-tracked-attributes-prompt>
          </ng-container>
        </ng-container>
        <ng-template #loading>
          <ngx-skeleton-loader
            count="4"
            appearance="line"
          ></ngx-skeleton-loader>
        </ng-template>
      </mat-card-content>
    </mat-card>
    <mat-card
      appearance="outlined"
      class="md:basis-1/3"
      [attr.data-cy]="testIds.CUSTOMER_CARD"
    >
      <mat-card-content>
        <h2>Customer</h2>
        <ngx-skeleton-loader
          *ngIf="customerLoading$ | async; else customerDetails"
          count="3"
          appearance="line"
        ></ngx-skeleton-loader>
        <ng-template #customerDetails>
          <ng-container
            *ngIf="customer$ | async as customer; else internalRepair"
          >
            <p [attr.data-cy]="testIds.CUSTOMER_NAME">
              <a
                matTooltip="View Customer"
                matTooltip-position="right"
                md-autohide="false"
                [routerLink]="['/customer', customer.id]"
              >
                {{ customer | customerName }}
              </a>
            </p>
            <p [attr.data-cy]="testIds.CUSTOMER_ADDRESS">
              {{ customer | customerAddress }}
            </p>
            <p [attr.data-cy]="testIds.CUSTOMER_CONTACT_DETAILS">
              {{ customer | customerContactDetails }}
            </p>
          </ng-container>
          <ng-template #internalRepair>
            <em [attr.data-cy]="testIds.CUSTOMER_INTERNAL_REPAIR"
              >This is an internal repair</em
            >
          </ng-template>
        </ng-template>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="md:basis-1/3">
      <mat-card-content>
        <app-job-settings [job]="job$ | async"></app-job-settings>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-col md:flex-row md:space-x-4">
    <div
      class="flex flex-col space-y-5 items-stretch md:flex-grow md:flex-shrink-0 md:basis-1/2 mb-4"
      [attr.data-cy]="testIds.EVENTS_LIST"
    >
      <app-add-event-buttons></app-add-event-buttons>
      <p class="text-2xl text-gray-500 pt-8 mx-3">Events</p>
      <app-workshop-job-event
        *ngFor="let event of events$ | async"
        [attr.data-cy]="testIds.EVENT_PREFIX + event.id"
        [event]="event"
      ></app-workshop-job-event>
    </div>
    <app-parts-list
      class="flex flex-col items-stretch md:flex-grow-0 md:flex-shrink md:basis-1/2"
      [job]="job$ | async"
      [finalized]="docketFinalized$ | async"
    ></app-parts-list>
  </div>
</div>
